import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {colors} from 'styles/shared';

const TabNavigation = styled.div`
  height: 2.6rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

const TabItem = styled.div`
  font-weight: bold;
  font-size: 2rem;
  line-height: 2.4rem;
  height: 2.6rem;
  color: ${props => (props.active ? colors.blue_darker : colors.blue_main)};
  text-transform: capitalize;
  cursor: pointer;
  border-bottom: ${props => (props.active ? `0.3rem solid ${colors.blue_darker}` : '')};
`;

TravelNavigation.propTypes = {
  tabs: PropTypes.array.isRequired,
  tabSelected: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

function TravelNavigation({tabs, tabSelected, onChange}) {
  return (
    <TabNavigation>
      {tabs.map(tab => {
        let isActiveTab = tab === tabSelected;

        return (
          <TabItem key={tab} active={isActiveTab} onClick={() => onChange(tab)}>
            {tab}
          </TabItem>
        );
      })}
    </TabNavigation>
  );
}

export default TravelNavigation;
